import { PricePipe } from '~modules/pipes/price.pipe';
export const maxValue = (value, max) => {
    if (`${value}`.length && +value > max) {
        return `Не может быть больше ${PricePipe(max)}`;
    }
    return null;
};
